module.exports = __webpack_public_path__ + "static/media/RoundedRect_Pink.c088fd78.png";